import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import i18 from '../../i18';
import { getDisplayValue } from '../../utils/formatName';

const styles = {
    controllerCell: {
        backgroundColor: '#F4F6F8',
        fontWeight: 'bold'
    }
};

class GridTextCell extends React.Component {
    render() {
        const { field, value } = this.props;
        const displayValue = getDisplayValue(value, field, this.props.row);
        let cellContent;
        if (field.needTranslate) {
            const translationKey = `enums.${displayValue}`;
            const translated = i18.t(translationKey);
            cellContent =
                translated === translationKey ? displayValue : translated;
        } else {
            cellContent = displayValue;
        }

        return (
            <TableCell
                key={field.id}
                align="left"
                sx={{
                    ...(field.needStyle && styles.controllerCell)
                }}
            >
                {cellContent && cellContent.length > 100
                    ? `${cellContent.slice(0, 100)}...`
                    : cellContent}{' '}
            </TableCell>
        );
    }
}

GridTextCell.propTypes = {
    value: PropTypes.any,
    field: PropTypes.shape({
        id: PropTypes.string.isRequired,
        needTranslate: PropTypes.bool,
        display: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
        needStyle: PropTypes.bool
    }).isRequired,
    row: PropTypes.object.isRequired
};

export default GridTextCell;
